const DAY_MS = 24 * 60 * 60 * 1000;

function toIsoDay(value) {
    if (!value) return '';
    if (value instanceof Date) {
        return new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate())).toISOString().slice(0, 10);
    }
    return String(value).slice(0, 10);
}

function normalizeName(value) {
    return String(value || '').trim().toLowerCase();
}

function formatDay(isoDay) {
    return new Date(`${isoDay}T00:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
}

export function computePersonPto(entries, name, email, fromDay, toDay) {
    if (!Array.isArray(entries) || !entries.length) return null;
    const n = normalizeName(name);
    const e = normalizeName(email);
    if (!n && !e) return null;

    const matches = entries.filter(a => {
        if (!a) return false;
        const an = normalizeName(a.memberName);
        const ae = normalizeName(a.memberEmail);
        if (n && an && (an === n || an.includes(n) || n.includes(an))) return true;
        return Boolean(e && ae && ae === e);
    });
    if (!matches.length) return null;

    const days = new Set();
    matches.forEach(a => {
        const start = toIsoDay(a.startDate);
        const end = toIsoDay(a.endDate) || start;
        if (!start) return;
        let cursor = new Date(`${start}T00:00:00Z`).getTime();
        const last = new Date(`${end}T00:00:00Z`).getTime();
        for (let guard = 0; cursor <= last && guard < 62; guard++, cursor += DAY_MS) {
            const dow = new Date(cursor).getUTCDay();
            if (dow === 0 || dow === 6) continue;
            const iso = new Date(cursor).toISOString().slice(0, 10);
            if (fromDay && iso < fromDay) continue;
            if (toDay && iso > toDay) continue;
            days.add(iso);
        }
    });

    const sorted = [...days].sort();
    if (!sorted.length) return null;
    const first = sorted[0];
    const last = sorted[sorted.length - 1];
    const range = first === last ? formatDay(first) : `${formatDay(first)} – ${formatDay(last)}`;
    return {
        days: sorted.length,
        first,
        last,
        label: `${range}`,
        tooltip: `${sorted.length} working day${sorted.length === 1 ? '' : 's'} of planned absence (${range})`
    };
}

export default {
    data() {
        return {
            ptoEntries: [],
            ptoFromDay: '',
            ptoToDay: '',
            ptoRangeKey: ''
        };
    },
    methods: {
        async loadPtoEntriesAsync(fromDate, toDate) {
            if (!this.isTeamOrHigher || !this.hasConfiguredTeamSpace) {
                this.ptoEntries = [];
                return;
            }
            const from = toIsoDay(fromDate);
            const to = toIsoDay(toDate);
            if (!from || !to || from > to) {
                this.ptoEntries = [];
                this.ptoRangeKey = '';
                return;
            }
            const key = `${from}|${to}`;
            if (key === this.ptoRangeKey) return;
            try {
                const resp = await this.$http.get('/TeamReport/Absences', { params: { startDate: from, endDate: to } });
                this.ptoEntries = (resp && resp.data && Array.isArray(resp.data.absences)) ? resp.data.absences : [];
                this.ptoFromDay = from;
                this.ptoToDay = to;
                this.ptoRangeKey = key;
            } catch (err) {
                this.ptoEntries = [];
                this.ptoRangeKey = '';
            }
        },
        getPersonPto(name, email) {
            return computePersonPto(this.ptoEntries, name, email, this.ptoFromDay, this.ptoToDay);
        }
    }
};